import { render, staticRenderFns } from "./UploadCert.vue?vue&type=template&id=b57a7bf2&scoped=true&"
import script from "./UploadCert.vue?vue&type=script&lang=js&"
export * from "./UploadCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57a7bf2",
  null
  
)

export default component.exports